/** @format */
import React from 'react'
import { useHistory } from 'react-router-dom'

import { Pagination } from 'antd'

import './style.css'

export default function Paginator(props) {
	const history = useHistory()

	return (
		<Pagination
			className='ph-paginator-main-container'
			defaultCurrent={1}
			current={props.page ? parseInt(props.page) : 1}
			onChange={(page) => history.push(`${props.route}/${page}`)}
			total={props.totalItems}
			defaultPageSize={20}
			pageSize={props.itemsPerPage ? props.itemsPerPage : 20}
			showTotal={(total) => `Total ${total} items`}
		/>
	)
}
